<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { ICustomer } from "../../entities/customer";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { formatCurrency } from "../../utils/date-utils";
  import { initDetail, record, save, stats } from "./customer.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.code != "" && $record.name != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ICustomer> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/customer/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/customer`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <div class="columns">
      <div class="column is-9">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input name="Codice" placeholder="codice" required={true} bind:value={$record.code} />
              </FormField>
            </div>

            <div class="column is-8">
              <FormField>
                <Input name="Denominazione" placeholder="Denominazione" required={true} bind:value={$record.name} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input name="Indirizzo" placeholder="indirizzo" required={false} bind:value={$record.address} />
              </FormField>
            </div>

            <div class="column is-2">
              <FormField>
                <Input name="CAP" placeholder="cap" required={false} maxlength={5} bind:value={$record.zipCode} />
              </FormField>
            </div>

            <div class="column is-4">
              <FormField>
                <Input name="Comune" placeholder="comune" required={false} bind:value={$record.city} />
              </FormField>
            </div>

            <div class="column is-2">
              <FormField>
                <Input name="Provincia" placeholder="provincia" maxlength={2} required={false} bind:value={$record.province} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input name="Codice Fiscale" placeholder="codice fiscale" required={false} bind:value={$record.fiscalCode} />
              </FormField>
            </div>

            <div class="column is-4">
              <FormField>
                <Input name="Partita IVA" placeholder="partita iva" required={false} bind:value={$record.vatNumber} />
              </FormField>
            </div>

            <div class="column is-4">
              <FormField>
                <ClfDropdown name="Tipo Cliente" schema="CUSTMRTYPE" required={false} clearVisible={true} bind:value={$record.clfCustomerType} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <Textarea name="Note" placeholder="note" required={false} bind:value={$record.notes} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
      <div class="column is-3">
        <div class="box">
          <h1 class="subtitle">Riepilogo</h1>
          {#if $stats}
            <p>Tempo totale: {$stats.totalTime}</p>
            <p>Tempo medio attività: {$stats.avgActivityTime}</p>
            <p>Costi anticipati: {formatCurrency($stats.costsAmount)}</p>
            <p>Pratiche in corso: {$stats.numDossiers}</p>
            <p>Numero attività: {$stats.numActivities}</p>
            <p>Numero utenti: {$stats.numUsers}</p>
            <p>&nbsp;</p>

            <UserTimeStats entries={$stats.topUsers} />
          {:else}
            <p>Tempo totale: --:--</p>
            <p>Tempo medio attività: --:--</p>
            <p>Costi anticipati: € 0.00</p>
            <p>Pratiche in corso: 0</p>
            <p>Numero attività: 0</p>
            <p>Numero utenti: 0</p>
          {/if}
        </div>
      </div>
    </div>
  {/if}
</MainLayout>
